var SDK_VERSION = '7.2.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
